/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * Result of admin replay or dismiss on an unresolved observation
 * @export
 * @interface MdmUnresolvedObservationActionResponse
 */
export interface MdmUnresolvedObservationActionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MdmUnresolvedObservationActionResponse
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MdmUnresolvedObservationActionResponse
     */
    observationId?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmUnresolvedObservationActionResponse
     */
    status?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MdmUnresolvedObservationActionResponse
     */
    materialized?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MdmUnresolvedObservationActionResponse
     */
    created?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MdmUnresolvedObservationActionResponse
     */
    updated?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MdmUnresolvedObservationActionResponse
     */
    markedStale?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MdmUnresolvedObservationActionResponse
     */
    examined?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmUnresolvedObservationActionResponse
     */
    resolved?: number;
    /**
     * 
     * @type {string}
     * @memberof MdmUnresolvedObservationActionResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmUnresolvedObservationActionResponse
     */
    userTimezone?: string;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof MdmUnresolvedObservationActionResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof MdmUnresolvedObservationActionResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the MdmUnresolvedObservationActionResponse interface.
 */
export function instanceOfMdmUnresolvedObservationActionResponse(value: object): value is MdmUnresolvedObservationActionResponse {
    return true;
}

export function MdmUnresolvedObservationActionResponseFromJSON(json: any): MdmUnresolvedObservationActionResponse {
    return MdmUnresolvedObservationActionResponseFromJSONTyped(json, false);
}

export function MdmUnresolvedObservationActionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmUnresolvedObservationActionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'observationId': json['observationId'] == null ? undefined : json['observationId'],
        'status': json['status'] == null ? undefined : json['status'],
        'materialized': json['materialized'] == null ? undefined : json['materialized'],
        'created': json['created'] == null ? undefined : json['created'],
        'updated': json['updated'] == null ? undefined : json['updated'],
        'markedStale': json['markedStale'] == null ? undefined : json['markedStale'],
        'examined': json['examined'] == null ? undefined : json['examined'],
        'resolved': json['resolved'] == null ? undefined : json['resolved'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function MdmUnresolvedObservationActionResponseToJSON(json: any): MdmUnresolvedObservationActionResponse {
    return MdmUnresolvedObservationActionResponseToJSONTyped(json, false);
}

export function MdmUnresolvedObservationActionResponseToJSONTyped(value?: MdmUnresolvedObservationActionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'observationId': value['observationId'],
        'status': value['status'],
        'materialized': value['materialized'],
        'created': value['created'],
        'updated': value['updated'],
        'markedStale': value['markedStale'],
        'examined': value['examined'],
        'resolved': value['resolved'],
        'errorMessage': value['errorMessage'],
        'userTimezone': value['userTimezone'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

